module.exports = core_47817c160b152cbdef74;